const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = theme => ({
  textFieldL: {
    marginRight: theme.spacing.unit * 2,
    display: "block",
    minWidth: minWidth / 2
  },
  textFieldR: {
    marginRight: theme.spacing.unit * 2,
    width: 420
  },
  targetHeading: {
    display: "flex",
    justifyContent: "space-between"
  },
  saveTarget: {
    backgroundColor: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    },
    margin: 10
  },
  lengthText: {
    fontWeight: "bold",
    paddingBottom: 20
  },
  modalSubHead: {
    fontWeight: "600!important",
    fontSize: "1.2rem!important",
    textTransform: "none!important"
  },
  restoreButton: {
    padding: "0 !important"
  }
});

export default styles;
